import { render, staticRenderFns } from "./ChallengerDetailPartners.vue?vue&type=template&id=77c79a21&scoped=true"
import script from "./ChallengerDetailPartners.vue?vue&type=script&lang=ts"
export * from "./ChallengerDetailPartners.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c79a21",
  null
  
)

export default component.exports